import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'
import { IVentricularAssistDeviceState } from '../store/ventricularAssistDevice.types'
import { getVentricularAssistDeviceSelector } from '../selectors'
import { VentricularAssistDeviceConstants } from '../store/ventricularAssistDevice.constants'
import { getServiceIdSelector } from '../../../user/selectors'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../../home/selectors'
import { IPcr } from '../../../pcr/store/pcr.types'
import {
  saveVentricularAssistDevice,
  setHideImpellaFields,
  setHideVadFields,
  setUpdateInputRows,
  clearFields,
} from '../store/ventricularAssistDevice.actions'
import { isEqual } from 'lodash'

export function* setVentricularAssistDeviceType() {
  const ventricularAssistDeviceState: IVentricularAssistDeviceState = yield select(getVentricularAssistDeviceSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    try {
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      const { ventricularAssistDeviceType, _hideVadFields, _hideImpellaFields } = ventricularAssistDeviceState

      // update hide booleans for VAD and Impella fields
      let hideVadFieldsTemp = true
      let hideImpellaFieldsTemp = true
      if (ventricularAssistDeviceType && ventricularAssistDeviceType.id !== null) {
        hideVadFieldsTemp = ventricularAssistDeviceType.id === 4
        hideImpellaFieldsTemp = ventricularAssistDeviceType.id !== 4
      } else {
        hideVadFieldsTemp = true
        hideImpellaFieldsTemp = true
      }

      const hasChanges = hideVadFieldsTemp !== _hideVadFields || hideImpellaFieldsTemp !== _hideImpellaFields

      if (hasChanges) {
        yield put(clearFields())
        yield put(setHideVadFields(hideVadFieldsTemp))
        yield put(setHideImpellaFields(hideImpellaFieldsTemp))
        yield put(setHideImpellaFields(hideImpellaFieldsTemp))
        yield put(setUpdateInputRows(true))
      }

      // update type in the list
      if (pcrDoc.patient?.ventricularAssistDeviceStateList && pcrDoc.patient?.ventricularAssistDeviceStateList.length) {
        const index = pcrDoc.patient?.ventricularAssistDeviceStateList?.findIndex(
          (data) => data.key === ventricularAssistDeviceState.key
        )

        if (index !== -1) {
          if (
            !isEqual(
              pcrDoc.patient.ventricularAssistDeviceStateList[index].ventricularAssistDeviceType,
              ventricularAssistDeviceType
            )
          ) {
            yield put(saveVentricularAssistDevice())
          }
        }
      } else {
        yield put(saveVentricularAssistDevice())
      }
    } catch (e) {
      yield put(throwPcrException(`setSuccessfulAttempt() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}

export function* setVentricularAssistDeviceTypeSaga() {
  yield takeLatest(
    [VentricularAssistDeviceConstants.SET_VENTRICULAR_ASSIST_DEVICE_TYPE],
    performWithMutexHOG,
    setVentricularAssistDeviceType
  )
}
